"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectBrandString, selectContactFormBackground, selectContactFormLink } from "@store/features/styleSchemaSlice";

export function Contact() {
  const { t } = useTranslation();
  const brandString = useSelector(selectBrandString);
  const contactBackground = useSelector(selectContactFormBackground);
  const contactFormLink = useSelector(selectContactFormLink);

  return (
    <div className="flex items-center w-full p-4 gap-4 text-white" style={{ background: contactBackground || 'transparent' }}>
      <div className="flex flex-col justify-center items-center space-y-4 w-full my-4">
        <h2 className="text-2xl font-bold">
          {t("landing.contactCard.title", { brandString })}
        </h2>
        <p className="">
          <Trans
            i18nKey="landing.contactCard.description"
            components={{
              emailLink: <a className="underline" href="mailto:kundenkarte@klierhairgroup.de">kundenkarte@klierhairgroup.de</a>,
              contactFormLink: <Link className="underline" target="_blank" href={contactFormLink || "https://www.klier.de/kontakt"}>Kontaktformular</Link>
            }}
          />
        </p>
        <Button className="text-white" onClick={() => window.open(contactFormLink || "https://www.klier.de/kontakt", "_blank", "noopener,noreferrer")}>{t("landing.contactCard.button")}</Button>
      </div>
    </div>
  );
}
